import React from "react";
import { Form, Input, Modal } from "../../atoms";

interface ICustomerPasswordModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (values: {
    currentPassword: string;
    newPassword: string;
  }) => Promise<void> | void;
}

export const CustomerPasswordModal: React.FC<ICustomerPasswordModalProps> = ({
  open,
  loading,
  onClose,
  onSubmit,
}) => {
  const [form] = Form.useForm();

  const handleFinish = async (values: any) => {
    await onSubmit(values);
    form.resetFields();
  };

  return (
    <Modal
      title="Αλλαγή κωδικού πρόσβασης"
      visible={open}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okText="Save"
      cancelText="Cancel"
      onOk={() => form.submit()}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form layout="vertical" form={form} onFinish={handleFinish}>
        <Form.Item
          name="currentPassword"
          label="* Current password"
          rules={[
            { required: true, message: "Παρακαλώ εισάγετε τον τρέχον κωδικό" },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="* New password"
          rules={[
            { required: true, message: "Παρακαλώ εισάγετε νέο κωδικό" },
            {
              min: 6,
              message: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες",
            },
          ]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="* Repeat new password"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Επαναλάβετε τον νέο κωδικό" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Οι κωδικοί δεν ταιριάζουν"));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>
      </Form>
    </Modal>
  );
};
